<mat-card appearance="outlined" id="classLink-login-card">
  <mat-card-content>
    <div id="classLink-login-container">
      <img id="classLink-logo" [src]="classLinkLogo" alt="Class Link Logo" />
      @if ((bannerStatus$ | async)) {
        <mat-toolbar
          id="classLink-login-banner"
          color="{{ bannerColor$ | async }}"
          fxFlexFill
          >
          <span id="classLink-login-banner-message">
            {{ bannerMessage$ | async }}
          </span>
        </mat-toolbar>
      }
      @if (showProgressSpinner) {
        <mat-progress-spinner
          fxLayoutAlign="center"
          mode="indeterminate"
          >
        </mat-progress-spinner>
      }
    </div>
    <mat-card-actions id="card">
      @if (!showProgressSpinner) {
        <button
          id="cancel-link"
          mat-raised-button
          fxFill
          color="primary"
          (click)="cancel()"
          >
          Back to Login
        </button>
      }
    </mat-card-actions>
  </mat-card-content>
</mat-card>
